import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import React, { useState } from 'react';
import { useAuth } from '../service/AuthContext';
/*

import { updateProfile } from 'firebase/auth';
import { doc, setDoc, addDoc } from "firebase/firestore";

import { db } from '../service/Firebase-config'
import { collection, addDoc } from "firebase/firestore";

*/

// this is the page for firebase data updating purpose
export default function DataUpdate() {
  const { login, logout, currentUser } = useAuth()
  const [email, setEmail] = useState("")
/*
  const homeworkData = {
    subject: 'Bio 12',
    teacher: 'Ms. Grace',
    teacherUid: 'OE1LBxgHduRx5TrTJmCUxgOK6IM2',
    teacherPhoto: 'https://firebasestorage.googleapis.com/v0/b/drhw2311.appspot.com/o/photo%2FOE1LBxgHduRx5TrTJmCUxgOK6IM2%2Fteacher4.jpg?alt=media&token=d54b7c79-17b6-4271-af57-6a4623741241',
    createdDate: new Date('December 28, 2023'),
    homework: 'Homework GP2',
  };

  const dataExample = {
    stringExample: 'Hello, World!',
    booleanExample: true,
    numberExample: 3.14159265,
    dateExample: Timestamp.fromDate(new Date('December 10, 1815')),
    arrayExample: [5, true, 'hello'],
    nullExample: null,
    objectExample: {
      a: 5,
      b: true
    }
  };
*/
  async function loginButtion() {
    try {
      await login(email, "test123").then(async (u) => {
 /*       updateProfile(u.user, {
          displayName: "Peter Parker", photoURL: "https://firebasestorage.googleapis.com/v0/b/drhw2311.appspot.com/o/photo%2F0FEvpAV892OolAqksLAS9cPvbyF3%2Fpeter.jpg?alt=media&token=17809b08-35c3-405f-b2e9-2c01706f318f"
        }).then(() => {
          console.log("profile updated: ", u.user.displayName)
        }).catch((error) => {
          console.log("Error on profile update: ", error.message)
        });

        await setDoc(doc(db, "students", u.user.uid), {
          uid: u.user.uid,
          role: "student",
          email: "peter@gmail.com",
          displayName: "Peter Parker",
          phone: "123-456-7890",
          info: "Taking computer science in 1st semester",
          grade: "Grade 11",
          school: "Bayview High School",
          parentPhone: "987-654-3210",
          totalStars: 25,
          photoUrl: "https://firebasestorage.googleapis.com/v0/b/drhw2311.appspot.com/o/photo%2F0FEvpAV892OolAqksLAS9cPvbyF3%2Fpeter.jpg?alt=media&token=17809b08-35c3-405f-b2e9-2c01706f318f"
        })*/

        alert('login: ' + u.user.displayName);
      })

    } catch (e) {
      alert("Error:: " + e.message)
    }

  }


  async function updateButtion() {
    /*
    const dbCollection = collection(db, 'students/0FEvpAV892OolAqksLAS9cPvbyF3/homeworks');
    const dataRef = await addDoc(dbCollection, homeworkData);
    alert('updated: ' + dataRef.id);
    */
    alert('nothing updated')
  }
  function logoutButtion() {
    logout().then(() => {
      alert("logout ok")
    }).catch((error) => {
      alert("logout out error!", error.message)
    });
  }


  return (
    <React.Fragment>
      <div style={{ margin: "10px" }}>
      <TextField id="outlined-basic" label="Email" variant="outlined" 
      onChange={(event) => {
        setEmail(event.target.value);
      }}
      />
      </div>
      <div style={{ margin: "10px" }}>
        <Button
          variant="contained"
          onClick={loginButtion}
        >
          Login
        </Button>
      </div>

      <div style={{ margin: "10px" }}>
        <Button
          variant="contained"
          onClick={updateButtion}
        >
          Update
        </Button>
      </div>

      <div style={{ margin: "10px" }}>
        <Button
          variant="contained"
          onClick={logoutButtion}
        >
          Logout
        </Button>
      </div>
      {currentUser && <div>
        <div style={{ margin: "10px" }}>User: {currentUser.displayName}</div>
        <div style={{ margin: "10px" }}> Image:
          <img src={currentUser.photoURL} alt="" />
        </div>
      </div>}





    </React.Fragment>

  )
}
